module.exports = __webpack_public_path__ + "e8ec817b568b975f650d5964289a4ebc.MP3";